import { render, staticRenderFns } from "./UlDialogDelete.vue?vue&type=template&id=4320b5cd&"
import script from "./UlDialogDelete.vue?vue&type=script&lang=ts&"
export * from "./UlDialogDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports